import React, { useState } from 'react';
import { Col, InputNumber, Row, Slider, Space } from 'antd';

const IntegerStep: React.FC = () => {
  const [inputValue, setInputValue] = useState<number>(1);

  const onChange = (newValue: number | null) => {
    if (typeof newValue === 'number') {
      setInputValue(newValue);
    }
  };

  return (
    <Row style={{ marginTop: '-10px' }}>
      <Col span={12}>
        <Slider min={1} max={100} onChange={onChange} value={typeof inputValue === 'number' ? inputValue : 0} />
      </Col>
      <Col span={4}>
        <InputNumber
          min={1}
          max={100}
          style={{
            margin: '0 16px',
          }}
          value={inputValue}
          onChange={onChange}
        />
      </Col>
    </Row>
  );
};

const CustomSlider: React.FC = () => (
  <Space
    style={{
      width: '100%',
      marginTop: '20px',
    }}
    direction="vertical"
  >
    <p>Opacity</p>
    <IntegerStep />
  </Space>
);

export default CustomSlider;
